// eslint-disable-next-line import/no-unresolved, import/extensions
import Success from './Success';

export default Success;
